import { render, staticRenderFns } from "./RedirectOptions.vue?vue&type=template&id=14905b0e"
import script from "./RedirectOptions.vue?vue&type=script&lang=js"
export * from "./RedirectOptions.vue?vue&type=script&lang=js"
import style0 from "./RedirectOptions.vue?vue&type=style&index=0&id=14905b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports